import { useActions } from '@mssgme/hooks';
import { useSelector } from 'react-redux';

export function useFilter() {
    const { ui } = useActions();
    const filter = useSelector((state) => state.ui.conversationsFilter);

    const setFilter = (filter) => ui.setConversationsFilter(filter);

    return [filter, setFilter];
}
